var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',{ref:"showForm",attrs:{"fields":_vm.fields,"no-buttons":""}},[_c('template',{slot:"appendContent"},[_c('employee-contract-asset-discount',{attrs:{"contract":_vm.contractProp}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }